export default {
  'app.login.userName': 'Username',
  'app.login.placeholder.email': 'Email address',
  'app.login.placeholder.password': 'Password',
  'app.login.display-name': 'Display Name',
  'app.login.email': 'Email Address',
  'app.login.password': 'Password',
  'app.login.message-invalid-credentials': 'Invalid email or password!',
  'app.login.message-invalid-verification-code': 'Invalid verification code!',
  'app.login.message-session-expired': 'Your session has expired. Please login again.',
  'app.login.remember-me': 'Remember Me',
  'app.login.forgot-password': 'Forgot Password',
  'app.login.signup': 'Sign Up',
  'app.login.login': 'Continue',
  'app.forgot-password.title': 'Forget Password',
  'app.forgot-password.success': 'A password reset link has been sent to your email.',
  'app.reset-password.title': 'Reset Password',
  'app.reset-password.placeholder.confirm': 'Confirm Password',
  'app.reset-password.reset': 'Reset Password',
  'app.reset-password.success':
    'Your password has been successfully reset. Please return to the login page to sign in.',
  'app.back-to-login': 'Back to Login',
  'app.register.already-have-account': 'Already have an account?',
  'app.login.dont-have-account': "Don't have an account?",
  'validation.email.required': 'Please enter your email address',
  'validation.email.wrong-format': 'Invalid email address',
  'validation.display-name.required': 'Please enter your display name',
  'validation.password.required': 'Please create a password for your account',
  'validation.confirm-password.match': 'The two passwords do not match',
  'signup.error.email_already_exists':
    'The email address is already associated with an existing account.',
  'app.login.sign-in-to-your-account': 'Sign in to your account',
  'app.login.otp.title': 'Enter your login code',
  'app.login.otp.subtitle': 'We sent an 8-digit code to {email}',
  'app.login.otp.sending': 'Sending verification code to your email...',
  'app.login.otp.code.placeholder': '8-digit code',
  'app.login.otp.code.required': 'Please enter the verification code',
  'app.login.otp.code.invalid': 'Please enter a valid 8-digit code',
  'app.login.otp.verify': 'Verify and sign in',
  'app.login.otp.resend': 'Resend code',
  'app.login.otp.resend-wait': 'Resend code in {seconds}s',
  'app.login.otp.back': 'Back to password login',
  'logout.success': 'You have been logged out successfully.',
};
